import { ISectionFeatures } from 'types/interfaces'

export interface ExtractFeatureIdsArgs {
  text: string
  comparisonFeatures: ISectionFeatures[]
}

// This is expeimental feature
// To do:
// 1. Add a way to add feature ids to the text
// 2. Add a way to remove feature ids from the text
// 3. Add a way to edit feature ids in the text
// 4. Add a way to delete feature ids from the text
// 5. Add a way to move feature ids in the text
// 6. Add a way to copy feature ids from the text
export function extractFeatureIdsFromText({
  text,
  comparisonFeatures,
}: ExtractFeatureIdsArgs): number[] {
  if (!text || !comparisonFeatures?.length) return []
  const normalized = text.toLowerCase()
  const matchedIds = new Set<number>()
  comparisonFeatures.forEach((group) => {
    group.features.forEach((feature) => {
      const name = (feature.name || '').toLowerCase()
      if (name && normalized.includes(name)) matchedIds.add(feature.id)
    })
  })
  return Array.from(matchedIds)
}

export interface BuildSectionFilterMapArgs {
  featureIds: number[]
  comparisonFeatures: ISectionFeatures[]
}

export function buildSectionFilterMap({
  featureIds,
  comparisonFeatures,
}: BuildSectionFilterMapArgs): Record<string, number[]> {
  const sectionToIds: Record<string, number[]> = {}
  if (!featureIds?.length || !comparisonFeatures?.length) return sectionToIds

  comparisonFeatures.forEach((group) => {
    group.features.forEach((feature) => {
      if (featureIds.includes(feature.id)) {
        const key = feature.section
        if (!sectionToIds[key]) sectionToIds[key] = []
        sectionToIds[key].push(feature.id)
      }
    })
  })

  return sectionToIds
}
